module.exports = __webpack_public_path__ + "img/fatto.92ea4376.svg";